import {Alert, Button, Col, Divider, Empty, message, Modal, Row, Spin} from "antd";
import {ADMIN_NEEDED_DOCUMENT_LIST, PREVIEW_DOC_TYPES, VIDEO_CODE_CAPTURED_VIDEOS} from "../../../util/Constants";
import {DownloadOutlined, EyeOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {CustomerDetailWrapperDto} from "../../../dto/admin/CustomerDetailWrapperDto";
import {
    MSG_FAILED_TO_FETCH_CAPTURED_VIDEO_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import documentService from "../../../service/documentService";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import PreviewModalComp from "../../../components/common/preview/PreviewModalComp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faVideo} from "@fortawesome/free-solid-svg-icons";

interface VideoVerificationInformationProps {
    customerDetailWrapperDto: CustomerDetailWrapperDto
}


const VideoVerificationInformation = (props: VideoVerificationInformationProps) => {
    const [isCapturedDocumentCompSpinning, setCapturedDocumentCompSpinning] = useState(false);
    const [capturedDocumentList, setCapturedDocumentList] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [docURL, setDocURL] = useState<string>();
    const [documentName, setDocumentName] = useState<string>("");
    const [isCapturedVideoSpinning, setCapturedVideoSpinning] = useState(false);
    const [isDownloading, setDownloading] = useState(false);
    const [recordedVideo, setRecordedVideo] = useState<UploadedDocumentDetailDto>();

    useEffect(() => {
        getCapturedList(props.customerDetailWrapperDto.customerMstDto.id)
    }, [])


    const getCapturedVideo = () => {
        setDownloading(true)

        let uploadDocumentDetailDto = recordedVideo;
        documentService.viewDocument(uploadDocumentDetailDto?.uploadDocumentDetailId as number).then(res => {
            if (res.data !== null) {
                const url = window.URL.createObjectURL(new Blob([res.data], {type: res.headers['content-type']}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', uploadDocumentDetailDto?.originalDocumentName as string);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setDownloading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_CAPTURED_VIDEO_ERROR).then();
                setDownloading(false)

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setDownloading(false)

        })
    }

    const getCapturedList = (customerId: any) => {
        setCapturedDocumentCompSpinning(true)
        let adminNeededDocumentList: string[] = ADMIN_NEEDED_DOCUMENT_LIST;
        adminNeededDocumentList.push(VIDEO_CODE_CAPTURED_VIDEOS);
        documentService.getCapturedDocumentListByType(customerId, adminNeededDocumentList).then(res => {
            if (res.data !== null) {
                let documentDtoList = res.data.results;
                if (null != documentDtoList) {
                    checkAndSetCapturedDocuments(documentDtoList)
                }
                setCapturedDocumentCompSpinning(false)

            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
                setCapturedDocumentCompSpinning(false)

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setCapturedDocumentCompSpinning(false)

        })
    }

    const checkAndSetCapturedDocuments = (documents: any) => {
        let capturedDocumentList: any[] = [];
        if (null != documents) {
            documents.forEach((doc: any) => {

                if (doc.documentTypeCode === VIDEO_CODE_CAPTURED_VIDEOS) {
                    let uploadDocumentDetailDto = doc.uploadDocumentDetailDto;
                    if (null == uploadDocumentDetailDto) {
                        setCapturedVideoSpinning(true)
                    } else {
                        setRecordedVideo(uploadDocumentDetailDto);
                    }
                } else {
                    if (null != doc.uploadDocumentDetailDto) {
                        capturedDocumentList.push(doc)
                    }
                }
            })
            setCapturedDocumentList(capturedDocumentList);
        }
    }

    const openModal = (document: UploadedDocumentDetailDto) => {
        setCapturedDocumentCompSpinning(true)
        documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
            setCapturedDocumentCompSpinning(false)
            if (res.data !== null) {
                setIsModalOpen(true)
                setDocumentName(document.documentTypeName);
                setDocURL(res.data.results)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setCapturedDocumentCompSpinning(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };

    const closeModal = () => {
        setDocURL("")
        setIsModalOpen(false)
    };

    const download = () => {
        let a = document.createElement('a');
        a.href = docURL;
        a.download = undefined != documentName ? documentName : "Document";
        a.click();
    }
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {
        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };

    return (
        <div>
            <Spin spinning={isCapturedDocumentCompSpinning}>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div>
                            <Divider orientationMargin="0" orientation="left"
                                     className='upload-document-divider'>Captured Images</Divider>
                            {capturedDocumentList && capturedDocumentList.length > 0 ?
                                <Row gutter={16}>
                                    {capturedDocumentList.map((document: any) => {


                                        return (
                                            document.uploadDocumentDetailDto !== null ?
                                                <Col xxl={6} xl={6} lg={12} style={{marginBottom: 8}}>
                                                    <div className='utility_bill img-nic'>
                                                        <div className='utulity_bill_icon_div'>
                                                            <div className="img_div">
                                                                <img
                                                                    src={document.uploadDocumentDetailDto?.thumbB64}
                                                                    alt=""/>
                                                            </div>
                                                            <div className='name_div'>
                                                                <h5>{document.uploadDocumentDetailDto?.documentTypeName}</h5>
                                                            </div>
                                                        </div>
                                                        <Button className='doc-view-btn'
                                                                onClick={() => openModal(document.uploadDocumentDetailDto)}><EyeOutlined/></Button>
                                                    </div>
                                                </Col> : ''
                                        )
                                    })}

                                </Row>
                                :
                                <Row gutter={16}>
                                    <Col xxl={24} xl={24} lg={24}>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <div>
                            <Divider orientationMargin="0" orientation="left"
                                     className='upload-document-divider'>Video Recording</Divider>
                            <Row gutter={[16, 16]}>
                                {!isCapturedVideoSpinning ?
                                    <Col span={24}>
                                        <Spin spinning={isDownloading} tip="Downloading...">
                                            <div className="video-download-div">
                                                <div className="video-file-icon-div">
                                                    <FontAwesomeIcon className={'video-icon'}
                                                                     icon={faVideo}/>
                                                </div>
                                                <div className="video-download-btn">
                                                    <Button size={'large'} type="link"
                                                            icon={<DownloadOutlined/>}
                                                            onClick={getCapturedVideo}>
                                                        Download
                                                    </Button>
                                                </div>
                                            </div>
                                        </Spin>


                                    </Col>
                                    : <Col xxl={24} xl={24} lg={24}>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                            <>
                                                <p>
                                                    If video verification is recorded, it will be uploaded here.
                                                </p>
                                                <Alert description="Processing time for compositions is typically about half the length
                                                    of the original recording. During periods of high demand, it might
                                                    take a few hours for compositions to be completed." type="info" showIcon />

                                            </>
                                        }/>
                                    </Col>
                                }
                            </Row>
                        </div>
                    </Col>
                </Row>
                {docURL && <Modal
                    className={checkDocumentContentType(docURL) == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : ""}
                    open={isModalOpen}
                    title={documentName}
                    onCancel={closeModal}
                    destroyOnClose={true}
                    width={checkDocumentContentType(docURL) == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                    footer={[
                        <Button type="primary" icon={<DownloadOutlined/>}
                                style={{background: '#FF7400', height: 40}} onClick={download}>
                            Download
                        </Button>]}
                >
                    <PreviewModalComp docURL={docURL} divHeight={'70vh'}/>
                </Modal>}
            </Spin>

        </div>
    )
}
export default VideoVerificationInformation